export enum LoginMethod {
  ByPhone = 'by-phone',
  ByQrCode = 'by-qrcode',
  ByAccount = 'by-account',
}

export enum LoginAccountType {
  Sports = 'sports', // 运动号
  Cooperation = 'cooperation', // 合作号
}

export interface ILoginResult {
  auth_token: string
}

/** POST /mgmt/account/login 返回 data */
export interface IMgmtAccountLoginResult {
  access_token: string
  token_type: string
}
